/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_IdentityInputs */

const en_onboarding_verify_identity = /** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's verify your identity and handle so your storefront URL is perfect.`)
};

const id_onboarding_verify_identity = /** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mari verifikasi identitas dan handle Anda agar URL etalase Anda sempurna.`)
};

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const es_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const fr_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const de_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const ja_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const zh_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const ar_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const it_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const ru_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const pt_onboarding_verify_identity = en_onboarding_verify_identity;

/** @type {(inputs: Onboarding_Verify_IdentityInputs) => LocalizedString} */
const ko_onboarding_verify_identity = en_onboarding_verify_identity;

/**
* | output |
* | --- |
* | "Let's verify your identity and handle so your storefront URL is perfect." |
*
* @param {Onboarding_Verify_IdentityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_identity = /** @type {((inputs?: Onboarding_Verify_IdentityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_IdentityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_verify_identity(inputs)
	if (locale === "es") return es_onboarding_verify_identity(inputs)
	if (locale === "fr") return fr_onboarding_verify_identity(inputs)
	if (locale === "de") return de_onboarding_verify_identity(inputs)
	if (locale === "ja") return ja_onboarding_verify_identity(inputs)
	if (locale === "zh") return zh_onboarding_verify_identity(inputs)
	if (locale === "ar") return ar_onboarding_verify_identity(inputs)
	if (locale === "id") return id_onboarding_verify_identity(inputs)
	if (locale === "it") return it_onboarding_verify_identity(inputs)
	if (locale === "ru") return ru_onboarding_verify_identity(inputs)
	if (locale === "pt") return pt_onboarding_verify_identity(inputs)
	return ko_onboarding_verify_identity(inputs)
});